export const PENDING_GUEST_SKILL_CLAIM_KEY = 'pendingGuestSkillClaim';
export const PENDING_GUEST_SKILL_CLAIM_INTENT = 'claimGuestSkillReward';
export const PENDING_GUEST_SKILL_CLAIM_TTL_MS = 60 * 60 * 1000;

function serializeCompletionState(completionState) {
  if (!completionState || typeof completionState !== 'object') {
    return {};
  }

  const serialized = { ...completionState };

  if (serialized.datetimeStarted instanceof Date) {
    serialized.datetimeStarted = serialized.datetimeStarted.toISOString();
  }

  return serialized;
}

/**
 * @param {{
 *   completionState: object,
 *   themeMeta?: { bigTopTheme?: boolean, theme?: string },
 * }} payload
 */
export function savePendingGuestSkillClaim({ completionState, themeMeta = {} }) {
  const payload = {
    intent: PENDING_GUEST_SKILL_CLAIM_INTENT,
    completionState: serializeCompletionState(completionState),
    bigTopTheme: themeMeta.bigTopTheme,
    theme: themeMeta.theme,
    savedAt: Date.now(),
  };

  sessionStorage.setItem(PENDING_GUEST_SKILL_CLAIM_KEY, JSON.stringify(payload));
}

/**
 * @returns {object|null}
 */
export function loadPendingGuestSkillClaim() {
  try {
    const raw = sessionStorage.getItem(PENDING_GUEST_SKILL_CLAIM_KEY);
    if (!raw) {
      return null;
    }

    const payload = JSON.parse(raw);
    if (payload?.intent !== PENDING_GUEST_SKILL_CLAIM_INTENT) {
      return null;
    }

    const savedAt = Number(payload.savedAt);
    if (!Number.isFinite(savedAt) || Date.now() - savedAt > PENDING_GUEST_SKILL_CLAIM_TTL_MS) {
      clearPendingGuestSkillClaim();
      return null;
    }

    return payload;
  } catch (error) {
    console.error('Failed to load pending guest skill claim:', error);
    clearPendingGuestSkillClaim();
    return null;
  }
}

export function clearPendingGuestSkillClaim() {
  sessionStorage.removeItem(PENDING_GUEST_SKILL_CLAIM_KEY);
}

export function hasPendingGuestSkillClaim() {
  return loadPendingGuestSkillClaim() != null;
}
